import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { AddTAConfiguration, getPolicuKeyList, getTaConfigurationList, updatTAConfiguration } from "./TAcofigurationRepo"
import { toast } from "react-toastify"
import { showToast } from "../../../utils/toastUtils"


interface paramsInterface{
    page:number,
    limi:number,
    search:string
}

export const useTaConfigurationList = ({enable = false,params}:{enable:boolean,params:paramsInterface})=>{
    return useQuery({
        queryKey:['TA_CONFI_LIST',params],
        queryFn:()=>getTaConfigurationList(params),
        enabled:enable,
        retry:false,
    })
}

export const useGetPolicyList = ({enable = false}:{enable:boolean})=>{
    return useQuery({
    queryKey:['GET_POLICY_LIST'],
    queryFn:getPolicuKeyList,
    retry:false,
    enabled:enable
  })

}



interface ReqBody{
   FromKm: number,
  ToKm: number,
  PolicyKey: string
}
export const useAddTAConfiguration = ()=>{
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn:(ReqBody:ReqBody)=>AddTAConfiguration(ReqBody),
        onSuccess:()=>{
        showToast.success('TA Added Successfully')
        queryClient.invalidateQueries({queryKey:['TA_CONFI_LIST']});
       },
       onError:(error:any)=>{
            showToast.error('Failed to Add TA Configuration');
            console.log('Failed to Add TA Configuration',error.message);
       }
    })
}



export const useUpdateTAConfiguration =()=>{
    
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:({ReqBody,id} : {ReqBody:ReqBody,id:number | null})=>updatTAConfiguration(ReqBody,id),
        onSuccess:()=>{
            showToast.success('TA Updated Successfully')
            queryClient.invalidateQueries({queryKey:['TA_CONFI_LIST']});
        },
        onError:(error:any)=>{
         console.log('Failed to Update TA ',error.message);
         showToast.error('Failed to Update TA');
        }
    })
} 